import { IconButton, InputAdornment, TextField } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import { useDebounce } from "@uidotdev/usehooks";
import { useState, useEffect } from "react";

export interface DeferredTextFieldProps {
  label: string;
  onChange: (emittedDebouncedValue: string) => void;
}

const DeferredTextField = (params: DeferredTextFieldProps) => {
  const [textValue, setTextValue] = useState<string>();
  const deferredTextValue = useDebounce(textValue, 1000);

  useEffect(() => {
    if (deferredTextValue !== undefined) {
      params.onChange(deferredTextValue);
    }
  }, [deferredTextValue, params.onChange]);

  return (
    <>
      <TextField
        fullWidth
        label={params.label}
        name={params.label}
        size="small"
        value={textValue ?? ""}
        onChange={(e) => {
          setTextValue(e.target.value);
        }}
        InputProps={{
          endAdornment: textValue ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="clear text"
                onClick={() => setTextValue("")}
                edge="end"
                size="small"
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    </>
  );
};

export default DeferredTextField;
